<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M3.14,45H.14v-8.37l1.75-1.75h16.45l9.58-10.39h10.2c4.07,0,6.71,2.97,6.71,7.56,0,3.36.04,11.45.04,11.45h-3s-.04-8.08-.04-11.45c0-1.7-.48-4.56-3.71-4.56h-8.89l-9.58,10.39H3.14v7.12Z" fill="currentcolor"/>
    <rect x="10.58" y="21" width="11.68" height="3" fill="currentcolor"/>
    <rect x="10.58" y="14.06" width="22.09" height="3" fill="currentcolor"/>
    <rect x="10.58" y="7.12" width="22.09" height="3" fill="currentcolor"/>
    <polygon points="6.62 33.55 3.62 33.54 3.64 .04 37.9 .04 39.58 1.81 39.58 23.13 36.58 23.13 36.58 3.04 6.64 3.04 6.62 33.55" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>